import {
  DocumentsSearchRequest,
  PolicyType,
} from '@aaa-ncnu-ie/mypolicy-api-documents';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { getCookie } from '../../utils/helpers';
import axios from '../axios';

// We really shouldn't have to do this, but we do because
// the documents API decided to create another one-off type
// for this instead of reusing something from the policies API.
// TODO: Fix this in the BFF when we get more time.
const translatePolicyTypeForDocumentsAPI = (
  policyType?: string
): PolicyType | undefined => {
  if (!policyType) {
    return undefined;
  }

  const uppercase = policyType.toUpperCase();

  switch (uppercase) {
    case 'PA':
    case 'AUTO':
      return 'AUTO';
    case 'PROPERTY':
      return 'Property';
    case 'PERSONAL UMBRELLA':
      return 'PUP';
    default:
      return undefined;
  }
};

// This documentSearch function/query leverages the documentRetrieve logic to retrieve either a policy's
// ID card or declarations page based on its type being auto or home.
export const getPrimaryPolicyDocument = async (
  policyNumber?: string,
  policyType?: string
) => {
  const custKey = getCookie('custkey');
  const convertedPolicyTypeFormat =
    translatePolicyTypeForDocumentsAPI(policyType);

  if (!policyNumber || !convertedPolicyTypeFormat) {
    return Promise.reject(new Error('Missing required params'));
  }

  const { data } = await axios.post<string>(
    `${import.meta.env.VITE_DOCUMENTS_API_URL}/v1/documents/search`,
    {
      policyNumber,
      policyType: convertedPolicyTypeFormat,
    } as DocumentsSearchRequest,
    {
      headers: {
        'Customer-Key': custKey,
      },
    }
  );

  const base64Response = await fetch(`data:application/pdf;base64,${data}`);
  const blob = await base64Response.blob();

  return URL.createObjectURL(blob);
};

export const useGetPrimaryPolicyDocumentQuery = (
  policyNumber?: string,
  policyType?: string,
  enabled = true
) =>
  useQuery({
    queryKey: [
      policyType === 'AUTO' ? 'idCard' : 'declaration',
      policyType,
      policyNumber,
    ],
    queryFn: () => getPrimaryPolicyDocument(policyNumber, policyType),
    enabled: !!(enabled && policyNumber && policyType !== undefined),
    staleTime: 100 * 60 * 10,
    retry: 3,
  });
